import { Fragment } from 'react';

import useOrgUnitAdminPurchases from './UseOrgUnitAdminPurchases';

import OrgUnitAdminPurchasesGrid from './OrgUnitAdminPurchasesGrid';
import OrgUnitAdminAdditionalPurchasesGrid from './OrgUnitAdminAdditionalPurchasesGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

import style from '../../Entry.module.css';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitAdminPurchasesWrite = () => {
  const { omeMeetOrgUnitEntryState, omeMeetOrgUnitEntryInfoState, omeMeetOrgUnitContactState, omeMeetOrgUnitAthleteEntryState,
    omeMeetOrgUnitAthleteEntryRelayRosterEntryState, omeMeetOrgUnitNonAthleteEntryState, omeMeetOrgUnitEntryPurchaseState,
    handleSubmit, errorState, onAdditionalPurchaseValueChanged, state, submitTeamEntryAllowed, onBackClicked, modalState,
    onModalCanceled, onDeletePurchaseItemDetailClicked, onDeletePurchaseItem, onExitButtonClicked } = useOrgUnitAdminPurchases();

  return (
    <Fragment>
      <div className={omeMeetOrgUnitEntryState.objData.orgUnit?.orgUnitName === 'Unattached' ? global.HideComponent : global.DisplayComponent}>
        <div className="row">
          <div className="col-xs-12">
            <Headings.H5>Requirements to be able to Make Purchases and Submit Entry</Headings.H5>
          </div>
          <div className='col-xs-12 usas-extra-bottom-margin'>
            <ul style={{ marginLeft: '15px' }}>
              <li>At least one entry contact must be provided {omeMeetOrgUnitEntryInfoState.objData?.hasEntryContact === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>
              <li>At least one athlete must be on the roster {omeMeetOrgUnitEntryInfoState.objData?.hasRosterAthlete === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>
              {omeMeetOrgUnitEntryInfoState.objData?.maxNumberOfAthletesForMeet && <li>The number of athletes on the roster is allowed according to the meet's max number of athletes {omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? (omeMeetOrgUnitEntryInfoState.objData?.includeRelayOnlySwimmersInMaxNumber === true ? `(includes Relay Only Swimmers)` : `(excludes Relay Only Swimmers)`) : ``} {omeMeetOrgUnitEntryInfoState.objData?.rosterAthleteCountAllowed === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>}
              <li>All athletes on the roster must have a status of 'Events Approved' {omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? "or 'Relay Only Swimmer'" : omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === false ? "('Relay Only Swimmer' status is not allowed)" : ''} {omeMeetOrgUnitEntryInfoState.objData?.hasApprovedEvents === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>
              <li>The number of credentials is allowed according to the meet's deck pass rules {omeMeetOrgUnitEntryInfoState.objData?.credentialsAmountAllowed === true ? <b>(Requirement Completed)</b> : <span style={{ color: 'red' }}>(Requirement Not Completed)</span>}</li>
            </ul>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H6>Required Purchases</Headings.H6>
            </div>
            <div className="col-xs-12">
              <OrgUnitAdminPurchasesGrid
                gridData={omeMeetOrgUnitEntryPurchaseState.objData?.purchaseItem}
                isLoading={omeMeetOrgUnitEntryPurchaseState.isObjLoading}
                onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
              />
            </div>
            {omeMeetOrgUnitEntryPurchaseState.objData?.additionalPurchase?.length > 0 &&
              <Fragment>
                <div className="col-xs-12 usas-extra-top-margin">
                  <Headings.H6>Additional Purchases</Headings.H6>
                </div>
                <div className="col-xs-12">
                  <OrgUnitAdminAdditionalPurchasesGrid
                    gridData={omeMeetOrgUnitEntryPurchaseState.objData?.additionalPurchase}
                    isLoading={omeMeetOrgUnitEntryPurchaseState.isObjLoading}
                    errorState={errorState}
                    onAdditionalPurchaseValueChanged={onAdditionalPurchaseValueChanged}
                  />
                </div>
              </Fragment>}
            <div className={state.showPayButton === true && submitTeamEntryAllowed() === true ? global.DisplayComponent : global.HideComponent}>
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
                  <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                  <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>&nbsp;
                  <PrimaryButton type="submit">{omeMeetOrgUnitEntryState.objData.status === Constants.WORKFLOW_STATUS_SUBMITTED ? 'Pay' : 'Pay & Submit'}</PrimaryButton>
                </div>
              </div>
            </div>
            <div className={state.showPayButton === false || submitTeamEntryAllowed() === false ? global.DisplayComponent : global.HideComponent}>
              <div className={style.FloatRight}>
                <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
                  <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                  <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </form>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={omeMeetOrgUnitEntryInfoState.isObjLoading || omeMeetOrgUnitContactState.isArrayLoading || omeMeetOrgUnitAthleteEntryState.isArrayLoading || omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoading ||
            omeMeetOrgUnitNonAthleteEntryState.isArrayLoading || omeMeetOrgUnitEntryPurchaseState.isObjLoading || state.tryRedirect === true}
        />
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={omeMeetOrgUnitEntryPurchaseState.isSaving}
        />
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={modalState.modalTitle}
          displayPopUp={modalState.displayPopUp}
          onModalCanceled={onModalCanceled}>
          <div className="row">
            <div className='col-xs-12'>
              <p><strong>Item Description:</strong> {modalState.itemDescription}</p>
              <p><strong>Item Price:</strong> {modalState.itemPrice}</p>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
              <PrimaryButton type="button" onClick={(e) => onDeletePurchaseItem(e, modalState.referenceEntity, modalState.referenceId)}>Delete</PrimaryButton>
            </div>
          </div>
        </PopUpModal>
      </div>
    </Fragment >
  );
};

export default OrgUnitAdminPurchasesWrite;